module.exports = __webpack_public_path__ + "static/media/documents.2a7b54a6.jpg";